import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { User } from './../../../../../../shared/src/lib/model/user.model';
import { Store } from '@ngrx/store';
import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router, RouterOutlet } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { FuseNavigationItem, FuseNavigationService, FuseVerticalNavigationComponent } from '@fuse/components/navigation';
import { buildNavigation } from '../../../core/navigation/navigation';
import { FuseMediaWatcherService } from '../../../../../../shared/src/lib/@fuse/services/media-watcher';
import { take } from 'rxjs/operators';
import { AppStateManage } from 'src/app/manage.states';
import { NgIf } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { FuseFullscreenComponent } from '../../../../../../shared/src/lib/@fuse/components/fullscreen/fullscreen.component';
import { FuseLoadingBarComponent } from '../../../../../../shared/src/lib/@fuse/components/loading-bar/loading-bar.component';
import { UserComponent } from '../../common/user/user.component';
import { FeatureFuseModule } from '../../../../../../shared/src/lib/feature-fuse/feature-fuse.module';

@Component({
    selector: 'classy-layout',
    templateUrl: './classy.component.html',
    encapsulation: ViewEncapsulation.None,
    standalone: true,
    imports: [FuseLoadingBarComponent, FuseVerticalNavigationComponent, NgIf, MatIconModule, MatButtonModule, FuseFullscreenComponent, RouterOutlet, UserComponent, FeatureFuseModule, TranslateModule],
})
export class ClassyLayoutComponent implements OnInit, OnDestroy {
    isScreenSmall: boolean;
    navigation: FuseNavigationItem[];
    user: User;
    private _unsubscribeAll: Subject<any> = new Subject<any>();

    /**
     * Constructor
     */
    constructor(
        private _activatedRoute: ActivatedRoute,
        private _router: Router,
        private store: Store<AppStateManage>,
        private _fuseNavigationService: FuseNavigationService,
        private _fuseMediaWatcherService: FuseMediaWatcherService,
        private translateService: TranslateService
    ) {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Getter for current year
     */
    get currentYear(): number {
        return new Date().getFullYear();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void {
        // Subscribe to navigation data
        this.store.pipe(takeUntil(this._unsubscribeAll)).subscribe(store => {
            this.user = store.user.me.user;
            // On suppose que les noms de groupes backend SONT directement les valeurs de l'enum PagePermission.
            const userPermissions = (this.user?.groups || []).map(g => g.name); // string[] de codes permissions
            this.navigation = buildNavigation(userPermissions);
        });
        // Subscribe to media changes
        this._fuseMediaWatcherService.onMediaChange$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(({ matchingAliases }) => {

                // Check if the screen is small
                this.isScreenSmall = !matchingAliases.includes('md');
            });

    }

    /**
     * On destroy
     */
    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Toggle navigation
     *
     * @param name
     */
    toggleNavigation(name: string): void {
        // Get the navigation
        const navigation = this._fuseNavigationService.getComponent<FuseVerticalNavigationComponent>(name);

        if (navigation) {
            // Toggle the opened status
            navigation.toggle();
        }
    }
}
